import { defaultToolStore } from "../../../boardState/stores/defaultToolStore.ts";
import { CREATE_DEFAULT_TOOL, EDIT_DEFAULT_TOOL } from "../constants.ts";

export const useDefaultCreateTool = () =>
  defaultToolStore.useState((it) => it.defaultCreateTool) ??
  CREATE_DEFAULT_TOOL;

export const useDefaultEditTool = () =>
  defaultToolStore.useState((it) => it.defaultEditTool) ?? EDIT_DEFAULT_TOOL;
